import { provideFetchOpportunityList } from '~/api-core/Opportunity/Fetch'

import type { Opportunity, OpportunityName } from '~/types/Opportunity'

export const useOpportunitiesStore = defineStore('opportunities', () => {
  const { coreFetch } = useProvideCoreFetch()
  const { $pinia } = useNuxtApp()
  const { GET_TAG_BY_NAME_FROM_TYPE } = useTagStore($pinia)

  const list = ref([] as Opportunity[])

  async function FETCH_OPPORTUNITIES() {
    list.value = await provideFetchOpportunityList(coreFetch)()
  }

  function GET_OPPORTUNITY_BY_NAME(name: OpportunityName) {
    return list.value.find((opportunity) => opportunity.name === name)
  }

  function GET_CURATOR_TYPE_TAG(name: OpportunityName) {
    const opportunity = GET_OPPORTUNITY_BY_NAME(name)
    if (!opportunity || !opportunity.curator_type) return

    return GET_TAG_BY_NAME_FROM_TYPE(
      opportunity.curator_type,
      'influencer_kind',
    )
  }
  return {
    list,
    FETCH_OPPORTUNITIES,
    GET_OPPORTUNITY_BY_NAME,
    GET_CURATOR_TYPE_TAG,
  }
})
